
import React from 'react'

const HomepageTop = () => (
  <div className="sentences_hp row mb20">
    <div className="mb20 col-xs-12 col-sm-6 col-md-3">
      <div className="icon_wrapper col-xs-3 col-md-5 col-lg-4 text-center">
        <span className="" />
      </div>
      <div className="col-xs-8 col-sm-8 col-md-7 col-lg-8">
        Podstawową siłą pedagogiczną jest dom rodzinny.
      </div>
    </div>
    <div className="mb20 col-xs-12 col-sm-6 col-md-3">
      <div className="icon_wrapper col-xs-3 col-md-5 col-lg-4 text-center">
        <span className="" style={{ background: '#08aaf4' }} />
      </div>
      <div className="col-xs-8 col-sm-8 col-md-7 col-lg-8">
        Kluczem do edukacji jest przeżycie piękna.
      </div>
    </div>
    <div className="mb20 col-xs-12 col-sm-6 col-md-3">
      <div className="icon_wrapper col-xs-3 col-md-5 col-lg-4 text-center">
        <span className="" style={{ background: '#fe5a27' }} />
      </div>
      <div className="col-xs-8 col-sm-8 col-md-7 col-lg-8">
        Wychowanie, jeśli nie jest wzorem i miłością, nie jest wychowaniem.
      </div>
    </div>
    <div className="mb20 col-xs-12 col-sm-6 col-md-3">
      <div className="icon_wrapper col-xs-3 col-md-5 col-lg-4 text-center">
        <span className="" style={{ background: '#624dd6' }} />
      </div>
      <div className="col-xs-8 col-sm-8 col-md-7 col-lg-8">
        Kreatywność znajduje wyraz w tych dzieciach, jeśli tylko na to pozwalamy.
      </div>
    </div>
  </div>
)

export default HomepageTop
